import { http } from '../../../plugins/axios'

const actions = {
  post ({commit, dispatch}, payload) {
    let url = `wizard`
    let options = {
      emulateJSON: false
    }
    http.defaults.headers.common['X-localization'] = payload.event.context.lang
    http.post(url, payload.event.data, options)
      .then(response => {
        commit('onPost',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
        payload.event.context.loader = false
      })
  },
  getInformation ({commit, dispatch}, payload) {
    let url = `information`
    let options = {
      emulateJSON: false
    }
    http.defaults.headers.common['X-localization'] = payload.event.context.lang
    http.get(url, {}, options)
      .then(response => {
        commit('onGetInformation',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  getPlans ({commit}, payload) {
    let url = 'plans'
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetPlans', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
}

export default actions